import script from "./CoreProgramEvaluationView.vue?vue&type=script&setup=true&lang=js"
export * from "./CoreProgramEvaluationView.vue?vue&type=script&setup=true&lang=js"

import "./CoreProgramEvaluationView.vue?vue&type=style&index=0&id=59d80988&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d80988"]])

export default __exports__